<template>
    <div class="plugin">
        <div id="dne"></div>
        <Header :dataSource="page" />

        <!-- HEADER STORE -->
        <div class="load" v-if="loadMerchantStore"></div>
        <HeaderStore :dataSource="dataMerchantStore" v-if="!loadMerchantStore" />

        
        <!-- CONTENT -->
        <section class="content-plugin">
            <div class="container">
                <div class="sections">
                    <div class="cont">
                        <div class="btn-section" :class="{active: sectionManage.guide === 'integration'}" @click='navSection("integration")'>
                            <!-- <small>{{getMyLanguage("Store","merchant.store.layout.guide-title")}}</small> -->
                            <small>Integração</small>
                        </div>

                        <div class="btn-section" :class="{active: sectionManage.guide === 'integrationLinks'}" @click='navSection("integrationLinks")'>
                            <!-- <small>{{getMyLanguage("Store","merchant.store.layout.guide-title")}}</small> -->
                            <small>Links</small>
                        </div>

                        <div class="btn-section" :class="{active: sectionManage.guide === 'webhook'}" @click='navSection("webhook")'>
                            <!-- <small>{{getMyLanguage("Store","merchant.store.staff.guide-title")}}</small> -->
                            <small>Webhook</small>
                        </div>
                        
                        <div class="btn-section" :class="{active: sectionManage.guide === 'logs'}" @click='navSection("logs")'>
                            <!-- <small>{{getMyLanguage("Store","merchant.store.staff.guide-title")}}</small> -->
                            <small>Logs</small>
                        </div>
                    </div>
                </div>


                <!-- LINKS -->
                <div class="cont-links" v-if="sectionManage.guide === 'integrationLinks'">
                    <h2 class="title-secondary">
                        Links de pagamentos
                        <small>Plugin DNE Pay</small>
                    </h2>

                    <div class="load" v-if="sectionManage.load"></div>


                    <div class="links">
                        <div class="bts-add">
                            <div class="add-plugin urlpayment" @click="openModal('urlPayment')">
                                <h3>Novo Link de Pagamento</h3>
                            </div>
                        </div>
                        
                        <div
                            :class="['link', link.status_extra]"
                            v-for="(link, index) in dataIntegrationLinks"
                            :key="index"
                            @click="openModalLink(link)">
                            
                            <div class="photo">
                                <img src="https://cdn.dnemarket.com/product_variant_attachment_default.png" v-if="!link.link_payload.items[0].image_url">
                                <img :src="link.link_payload.items[0].image_url" :alt="link.link_payload.items[0].name" v-else>
                            </div>

                            <div class="cont-link">
                                <h3>
                                    {{link.link_payload.items[0].name}}

                                    <strong class="price">
                                        <i>{{link.link_payload.items[0].price.toLocaleString('pt-BR', { style: 'currency', currency: instrumentTickerShort })}}</i>
                                        <small>{{link.link_payload.items[0].price}}</small>
                                    </strong>
                                </h3>

                                <div class="description" v-if="link.link_payload.items[0].description">{{link.link_payload.items[0].description}}</div>

                                <div class="resume">
                                    <span>
                                        Status:
                                        <strong>{{link.status_extra}}</strong>
                                    </span>

                                    <span>
                                        Start:
                                        <strong>{{ datePeriod(link.link_start_date) }}</strong>
                                    </span>

                                    <span>
                                        End:
                                        <strong>{{ datePeriod(link.link_end_date) }}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- PLUGIN -->
                <div class="cont-plugin" v-if="sectionManage.guide === 'integration'">
                    <h2 class="title-secondary">
                        <!-- <small>{{storeName}}</small> -->
                        <!-- {{getMyLanguage("Merchant","campaigns.title")}} -->
                        Integração
                        <small>Plugin DNE Pay</small>
                    </h2>

                    <p class="obs">Integre-se ao nosso plugin de forma simples e aproveite todos os benefícios do nosso ecossistema digital diretamente no seu negócio</p>

                    <div class="bts-add">
                        <div class="add-plugin ecommerce" @click="openModal('ecommerce')">
                            <h3>Integração Ecommerce</h3>
                        </div>

                        <div class="add-plugin frontoffice" @click="openModal('frontOffice')">
                            <h3>Integração Front Office</h3>
                        </div>
                       
                        <div class="add-plugin widget" @click="openModal('widget')">
                            <h3>Widget (para sites)</h3>
                        </div>
                    </div>
                </div>



                <!-- WEBHOOK -->
                <div class="cont-webhook" v-if="sectionManage.guide === 'webhook'">
                    <h2 class="title-secondary subtitle">
                        Webhook
                        <small>Plugin DNE Pay</small>
                    </h2>

                    <div class="load" v-if="sectionManage.load"></div>

                    <!-- WEBHOOK > LIST -->
                    <div class="webhook-list" v-if="webhookPlace == 'list'">
                        <div class="header-tools header-webhook" v-if="!sectionManage.load">
                            <div class="search-bar">
                                <input type="text" class="form form-search" id="searchWebHook" placeholder="WebHook name" v-on:keyup="filterWebHook">
                            </div>

                            <div class="add-webhook" @click="openWebHook('new')">Create Webhook</div>
                        </div>

                        <div class="scroll-horizontal" v-if="!sectionManage.load">
                            <table class="list-result">
                                <thead class="header-list">
                                    <tr>
                                        <th class="text-left">Name</th>
                                        <th class="full text-left">Target</th>
                                        <th>Status</th>
                                        <th>Type</th>
                                        <th>Created</th>
                                    </tr>
                                </thead>

                                <tbody id="drop-list-webhook">
                                    <tr class="list"
                                        v-for="(item, indexWebHook) in dataWebHook.webhook"
                                        :key="indexWebHook"
                                        @click="openWebHook('upd', item)">

                                        <td class="text-left"><span>{{ item.name }}</span></td>
                                        <td class="full text-left"><span :title="item.address">{{ item.address }}</span></td>
                                        <td class="status" :class="item.status_extra"><span>{{ item.status }}</span></td>
                                        <td><span>{{ item.type.type }}</span></td>
                                        <td><span>{{ dateTime(item.created_at) }}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- <pre>{{dataWebHook.webhook[0]}}</pre> -->
                    </div>


                    <!-- WEBHOOK > NEW / UPD -->
                    <div class="webhook-manager" v-if="webhookPlace == 'manager'">
                        <div class="webhook-form">
                            <div>
                                <label>
                                    <strong>Webhook Name</strong>

                                    <input type="text" class="form" maxlength="50"
                                        v-model="webhookManager.data.name"
                                        :class='{error: errorForm.webhook.name}'
                                        @keydown="errorForm.webhook.name = false">
                                </label>

                                <label>
                                    <strong>Target</strong>

                                    <input type="text" class="form"
                                        v-model="webhookManager.data.address"
                                        :class='{error: errorForm.webhook.address}'
                                        @keydown="errorForm.webhook.address = false"
                                        @blur="validateAddress">
                                    
                                    <div class="error" v-if="errorForm.webhook.address">Invalid URL (target)</div>
                                </label>

                                <label v-if="webhookManager.action == 'upd'" class="secret_code" for="">
                                    <div class="form-group-check">
                                        <div>
                                            <strong>Secret (SHA-256) </strong>
                                            <small>Automatic</small>
                                        </div>

                                        <input
                                            type="checkbox"
                                            id="secretRotate"
                                            class="form-check"
                                            v-model="webhookManager.data.secret_rotate"
                                            @change="handleSecretRotateChange()" />
                                            
                                        <label for="secretRotate" class="form-check-label">
                                            Secret rotate
                                        </label>
                                    </div>

                                    <div class="secret-sha">
                                        <div class="btn-copy"
                                            :class="{copying: sectionManage.copying}"
                                            @click="copyCode(webhookManager.data.secret)"
                                            v-if="webhookManager.data.secret">
                                            
                                            <span>Copy</span>
                                        </div>

                                        <div class="form form-disabled">
                                            <span>{{ webhookManager.data.secret }}</span>
                                        </div>
                                    </div>
                                </label>

                                <label>
                                    <strong>Webhook type</strong>
                                    
                                    <select class="form"
                                        v-if="webhookManager.action == 'new'"
                                        v-model="webhookManager.data.type"
                                        @click="(webhookManager.data.actions = []) && (webhookManager.code = '')">
                                        
                                        <option
                                            :value="item.type_code"
                                            v-for="(item, indexWebHookTypes) in dataWebHook.types"
                                            :key="indexWebHookTypes">
                                            
                                            {{ item.type }}
                                        </option>
                                    </select>

                                    <div class="form form-disabled" v-else>
                                        <span>{{ dataWebHook.types.filter(typeName => typeName.type_code == webhookManager.data.type)[0].type }}</span>
                                    </div>
                                </label>

                                <div class="actions" v-if="webhookManager.data.type">
                                    <label>
                                        <strong>Webhook Actions</strong>
                                    </label>

                                    <div class="empty" v-if="dataWebHook.types.filter(type => type.type_code == webhookManager.data.type)[0].actions.length == 0">No action available</div>

                                    <div class="options" v-else>
                                        <div class="form-group-check" 
                                            v-for="(item, indexWebHookTypes) in dataWebHook.types.filter(type => type.type_code == webhookManager.data.type)[0].actions" 
                                            :key="indexWebHookTypes">
                                            
                                            <input class="form-check"
                                                type="checkbox"
                                                :id="'checkbox-' + item.Id"
                                                :checked="webhookManager.data.actions.includes(item.Id)"
                                                @change="handleCheckboxChange(item, $event)" />
                                                
                                            <label :for="'checkbox-' + item.Id" class="form-check-label">
                                                {{ item.action }}
                                            </label>
                                        </div>
                                    </div>

                                </div>

                                <!-- <pre>{{webhookManager.data}}</pre> -->

                                <a href="#" class="btn-documentation">Webhook Documentation</a>

                                <div class="load" v-if="loadSave"></div>

                                <div class="bts-webhook" v-else>
                                    <div class="bts" v-if="!flowDelete">
                                        <div class="btn-cancel" @click="closeWebHook()">Cancel</div>

                                        <div class="btn-primary"
                                            v-if="webhookManager.action == 'new'"
                                            @click="saveWebhook()">
                                            
                                            Create
                                        </div>

                                        <div class="btn-primary"
                                            v-else
                                            @click="saveWebhook()">
                                            
                                            Update
                                        </div>

                                    </div>

                                    <div class="delete" v-if="webhookManager.action == 'upd' && !flowDelete">
                                        <div class="btn-delete" @click="flowDelete = true">Delete Webhook</div>
                                    </div>

                                    
                                    <!-- DELETE CONFIRM -->
                                    <div class="delete-webhook" v-if="flowDelete">
                                        <p>
                                            <strong>Are you sure you want to delete this Webhook?</strong>
                                        </p>

                                        <div class="bts">
                                            <div class="btn-cancel" @click="flowDelete = false">
                                                No delete
                                            </div>

                                            <div class="btn-primary" @click="deleteWebhook()">
                                                Confirm
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="webhook-code">
                            <div class="btn-copy" :class="{copying: sectionManage.copying}" @click="copyCode(webhookManager.code)" v-if="webhookManager.code"><span>Copy code</span></div>
                            <div class="btn-copy disabled" v-else><span>Copy code</span></div>

                            <div class="code">
                                <pre>{{ webhookManager.code }}</pre>
                            </div>
                        </div>
                    </div>
                </div>



                <!-- LOGS -->
                <div class="cont-logs" v-if="sectionManage.guide === 'logs'">
                    <h2 class="title-secondary subtitle">
                        Logs
                        <small>Plugin DNE Pay</small>
                    </h2>

                    <div class="load" v-if="sectionManage.load"></div>

                    <div class="header-tools header-logs" v-if="!sectionManage.load">
                        <div class="search-bar">
                            <input type="text" class="form form-search" id="searchLogs" placeholder="Reference log" v-on:keyup="filterLogs">
                        </div>
                    </div>

                    <div class="scroll-horizontal" v-if="!sectionManage.load">
                        <table class="list-result">
                            <thead class="header-list">
                                <tr>
                                    <th class="full text-left">Reference</th>
                                    <th>Webhook</th>
                                    <th>Status</th>
                                    <th>HTTP code</th>
                                    <th>Attempt</th>
                                    <th>First sent</th>
                                    <th>Last sent</th>
                                    <th>Next retry</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody id="drop-list-logs">
                                <tr class="list"
                                    v-for="(item, indexLogs) in dataLogs"
                                    :key="indexLogs"
                                    @click="openLog(item)">

                                    <td class="full text-left">
                                        <span>
                                            {{ item.entity_id }}
                                            <small>{{ item.action }}</small>
                                        </span>
                                    </td>
                                    <td><span>{{ item.webhook }}</span></td>
                                    <td class="status" :class="item.status_extra"><span>{{ item.status }}</span></td>
                                    <td><span>{{ item.http_code }}</span></td>
                                    <td><span>{{ item.attempt }}</span></td>
                                    <td><span>{{ dateTime(item.created_at) }}</span></td>
                                    <td><span>{{ dateTime(item.updated_at) }}</span></td>
                                    <td><span v-if="item.next_retry != item.updated_at">{{ dateTime(item.next_retry) }}</span></td>
                                    <td><img src="~@/assets/images/icons/information.svg" alt="Informations" class="icon"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- <pre>{{dataLogs[0]}}</pre> -->
                </div>
            </div>
        </section>
    </div>



    <!-- LOGS > SIDEBAR -->
    <div class="sidebar-logs" v-if="logSidebar.show">
        <div class="close" @click="closeLog()"></div>

        <div class="cont">
            <div class="header-logs">
                <h3>
                    <small>Webhook type:</small>
                    {{ logSidebar.data.webhook }}
                </h3>

                <p><strong>Id: </strong>{{ logSidebar.data.entity_id }}</p>
            </div>

            <div class="details">
                <h3>
                    <span>Event details</span>

                    <span class="load" v-if="resend.load"></span>

                    <span class="btn-resend"
                        @click="resendLog()"
                        v-else>
                        
                        <span>Resend</span>
                    </span>
                </h3>

                <table>
                    <tr>
                        <td><strong>Webhook name</strong></td>
                        <td><span>{{ logSidebar.data.webhook }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Action</strong></td>
                        <td><span>{{ logSidebar.data.action }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Status</strong></td>
                        <td class="status" :class="logSidebar.data.status_extra"><span>{{ logSidebar.data.status }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>HTTP code</strong></td>
                        <td><span>{{ logSidebar.data.http_code }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>First sent</strong></td>
                        <td><span>{{ dateTime(logSidebar.data.created_at) }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Last sent</strong></td>
                        <td><span>{{ dateTime(logSidebar.data.updated_at) }}</span></td>
                    </tr>
                    <tr v-if="logSidebar.data.next_retry != logSidebar.data.updated_at">
                        <td><strong>Next retry</strong></td>
                        <td><span>{{ dateTime(logSidebar.data.next_retry) }}</span></td>
                    </tr>
                </table>
            </div>

            <div class="payload-code">
                <div class="btn-copy"
                    :class="{copying: sectionManage.copying}"
                    @click="copyCode(logSidebar.data.payload)"
                    v-if="logSidebar.data.payload">
                    
                    <span>Copy code</span>
                </div>

                <div class="btn-copy disabled" v-else>
                    <span>Copy code</span>
                </div>

                <div class="code">
                    <pre>{{ convertCode(logSidebar.data.payload) }}</pre>
                </div>
            </div>
        </div>
    </div>



    <!-- MODAL LINK -->
    <div class="modal modal-link" v-if="modalLink.show">
        <div class="modal-cont">
            <div class="modal-close" @click="closeModalLink()"></div>
            <div class="modal-scroll">
                <h2 class="title-secondary">Link de pagamento</h2>

                <div class="load" v-if="modalLink.load"></div>

                <div class="cont-modal-link" v-if="!modalLink.load">
                    <div class="photo">
                        <img src="https://cdn.dnemarket.com/product_variant_attachment_default.png" v-if="!modalLink.data.link_payload.items[0].image_url">
                        <img :src="modalLink.data.link_payload.items[0].image_url" :alt="modalLink.data.link_payload.items[0].name" v-else>
                    </div>
                    
                    <div>
                        <h3>
                            {{modalLink.data.link_payload.items[0].name}}
                            <small>{{modalLink.data.link_payload.items[0].price}}</small>
                        </h3>

                        <div class="description" v-if="modalLink.data.link_payload.items[0].description">{{modalLink.data.link_payload.items[0].description}}</div>
                    </div>
                </div>

                <!-- <a :href="modalLink.link" class="link-payment">{{modalLink.link}}</a> -->
                <div class="btn-copy-link" @click="copyCode(modalLink.link)">
                    <div>
                        <span>{{modalLink.link}}</span>
                    </div>
                </div>
                
                <div class="delete" v-if="!modalLink.load">
                    <div class="cont-delete">
                        <p>Deseja deixar inativo este link de pagamento?</p>
                        <div class="btn-primary" @click="updateModalLink('delete')">Sim</div>
                    </div>
                </div>
            </div>
        </div>
    </div>




    <!-- MODAL GENERATE CODE -->
    <div class="modal" v-if="modalPlugin.show">
        <div class="modal-cont">
            <div class="modal-close" @click="closeModal()"></div>

            <div class="modal-scroll">
                <h2 class="title-secondary">
                    {{ getMyLanguage("Plugin","modal.title." + modalPlugin.type) }}
                </h2>

                <div class="fields">

                    <!-- PRODUCT -->
                    <div class="field" v-if="modalPlugin.type == 'widget' || modalPlugin.type == 'urlPayment'">
                        <!-- <label>
                            <span>
                                Origem do produto
                            </span>
                            <select name="" id="" class="form">
                                <option value="">
                                    Produto avulso
                                </option>

                                <option value="">
                                    Produto disponível também no DNE Market
                                </option>
                            </select>
                        </label> -->


                        <!-- NAME -->
                        <label>
                            <span class="info">
                                Nome do produto
                                <!-- <i><span>Lorem ipsum dolor sit amet consectetur adipisicing elit.</span></i> -->
                            </span>

                            <input type="text" class="form"
                                v-model="pluginCode.items[0].name"
                                @blur="updateUrlIframe()">
                        </label>
                        

                        <!-- IMAGE -->
                        <label>
                            <span class="info">
                                Url da imagem do produto
                                <i><span>Copie o link da imagem e cole aqui.</span></i>
                            </span>

                            <input type="text" class="form"
                                v-model="pluginCode.items[0].image_url"
                                @blur="updateUrlIframe()">
                        </label>


                        <!-- DESCRIPTION -->
                        <label>
                            <span class="info">
                                Breve descrição
                                <i><span>Faça uma breve descrição com no máximo 200 caracteres.</span></i>
                            </span>

                            <span class="cont">{{pluginCode.items[0].description.length}}/200</span>

                            <textarea class="form" maxlength="200"
                                v-model="pluginCode.items[0].description"
                                @blur="updateUrlIframe()"></textarea>
                        </label>

                        <!-- <label>
                            <span>
                                Entregável
                            </span>
                            <select name="" id="" class="form">
                                <option value=""
                                    v-if="modalPlugin.code.type != 'free-shipping' && modalPlugin.code.type != 'cashback'">

                                    {{ getMyLanguage("Campaigns","modal.campaign.type-percent") }}
                                </option>

                                <option value="">
                                    {{ getMyLanguage("Campaigns","modal.campaign.type-currency") }}
                                </option>
                            </select>
                        </label> -->
                    </div>


                    <!-- PRICE -->
                    <div class="field" v-if="modalPlugin.type == 'widget' || modalPlugin.type == 'urlPayment'">
                        <label>
                            <span class="info">
                                * Preço do produto
                                <i><span>Valor correspondente a sua moeda preferencial.</span></i>
                            </span>
                        </label>

                        <div class="currency-price">
                            <div>
                                <label>
                                    * Sua moeda preferencial
                                    <div>
                                        <select class="form" v-model="pluginCode.instrument" @change="updateUrlIframe()">
                                            <option
                                                v-for="currency in modalPlugin.currency"
                                                :key="currency.trade_asset.id"
                                                :value="currency.ticker" >

                                                {{getMyLanguage("Currency","asset." + currency.trade_asset.short)}}
                                            </option>
                                        </select>
                                    </div>
                                </label>
                            </div>

                            <div class="currency">
                                <i>{{modalPlugin.currency.filter(asset => asset.ticker == pluginCode.instrument)[0].trade_asset.short}}</i>
                                
                                <label>
                                    Preço em {{getMyLanguage("Currency","asset." + modalPlugin.currency.filter(asset => asset.ticker == pluginCode.instrument)[0].trade_asset.short)}}
                                    <div>
                                        <input type="text" class="form"
                                            v-model="modalPlugin.formattedPrice"
                                            @blur="updateUrlIframe()" />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>


                    <!-- CAMPAIGN -->
                    <!-- <div class="field">
                        <label>
                            <span class="info">
                                Campanha
                                <i><span>Selecione uma campanha para aplicar neste plugin.</span></i>
                            </span>

                            <select class="form"
                                v-model="pluginCode.items[0].campaign_id"
                                @blur="updateUrlIframe()">

                                <option :value="campaign.id" v-for="(campaign, indexCampaign) in modalPlugin.campaigns" :key="indexCampaign">
                                    {{ campaign.name }}
                                </option>
                            </select>
                        </label>
                    </div> -->


                    <!-- RULES -->
                    <div class="field" v-if="modalPlugin.type == 'widget' || modalPlugin.type == 'urlPayment'">
                        <label>
                            <span class="info">
                                Regras
                                <i><span>Defina as regras de venda deste produto/serviço.</span></i>
                            </span>
                        </label>

                        <div class="rules">
                            <label>
                                Início
                                <input type="date" class="form">
                            </label>

                            <label>
                                Fim
                                <input type="date" class="form">
                            </label>

                            <label>
                                Máximo
                                <input type="number" class="form" inputmode="numeric" pattern="[0-9]*" min="0" max="100">
                                <p><small>Informe "0" para vendas ilimitadas.</small></p>
                            </label>
                        </div>
                    </div>


                    <!-- LAYOUT -->
                    <div class="field layout" v-if="modalPlugin.type != 'frontOffice'">
                        <label>
                            <span class="info">
                                Layout
                                <i><span>Ative e desative o cabeçalho ou o rodapé neste plugin.</span></i>
                            </span>
                        </label>

                        <div class="options">
                            <div class="form-group-check"
                                :class="{ active: pluginCode.layout[item.key] }"
                                v-for="(item, indexLayout) in modalPlugin.layout" 
                                :key="indexLayout">

                                <input 
                                    class="form-check"
                                    type="checkbox"
                                    :id="'checkbox-' + item.key"
                                    v-model="pluginCode.layout[item.key]" />
                                    
                                <label :for="'checkbox-' + item.key" class="form-check-label" @click="updateUrlIframe()">
                                    {{ item.key }}
                                </label>
                            </div>
                        </div>
                    </div>


                    <!-- FRONT OFFICE -->
                    <div class="front-office" v-if="modalPlugin.type == 'frontOffice'">
                        <!-- <h2 class="title-secondary" v-if="modalPlugin.code.show">Integração</h2> -->

                        <div class="plugin-code " v-if="modalPlugin.code.show">
                            <div class="btn-copy" :class="{copying: modalPlugin.code.copying}" @click="copyCodeIntegration()">
                                <span>Copiar código</span>
                            </div>

                            <xmp class="code">
                                <span id="headerIntegration"></span>
                                {{ pluginCode }}
                                <span id="footerIntegration"></span>
                            </xmp>
                        </div>
                    </div>


                    <!-- TYPE PLUGIN -->
                    <div class="nav-type-plugin" v-if="modalPlugin.type != 'frontOffice' && (modalPlugin.iframe.show || modalPlugin.code.show)">
                        <div class="type"
                            :class="{active: modalPlugin.typePlugin.code == 'plugin'}"
                            @click="changeTypePlugin('plugin'), updateUrlIframe()">
                                
                            Plugin de Venda
                        </div>

                        <div class="type"
                            :class="{active: modalPlugin.typePlugin.code == 'plugin-info'}"
                            @click="changeTypePlugin('plugin-info'), updateUrlIframe()">
                            
                            Plugin de Informações
                        </div>
                    </div>


                    <!-- PLUGIN -->
                    <div class="plugin-show-iframe" v-if="modalPlugin.type != 'frontOffice'">
                        <h2 class="title-secondary" v-if="modalPlugin.iframe.show || modalPlugin.code.show">Preview</h2>

                        <div class="plugin-iframe" v-if="modalPlugin.code.show">
                            <div v-if="modalPlugin.iframe.show">
                                <iframe :src="modalPlugin.iframe.url" frameborder="0"></iframe>
                            </div>
                        </div>
                    </div>


                    <!-- PLUGIN CODE -->
                    <div class="plugin-show-code" v-if="modalPlugin.type == 'ecommerce' || modalPlugin.type == 'widget'">
                        <h2 class="title-secondary" v-if="modalPlugin.code.show">Código do plugin</h2>

                        <div class="plugin-code plugin-sale" v-if="modalPlugin.code.show">
                            <div class="btn-copy" :class="{copying: modalPlugin.code.copying}" @click="copyCodePlugin()">
                                <span>Copiar código</span>
                            </div>

                            <xmp class="code">
                                <span id="headerCode"></span>
                                    {{ pluginCode }}
                                <span id="footerCode"></span>
                            </xmp>
                        </div>
                    </div>


                    <!-- URL PAY -->
                    <div class="lnk-payment" v-if="modalPlugin.type == 'urlPayment' && modalPlugin.code.show && modalPlugin.typePlugin.code == 'plugin'">
                        <h2 class="title-secondary">Link de pagamento</h2>

                        <div class="bts center">
                            <div class="btn-primary"
                                v-if="!modalPlugin.urlPay.load && !modalPlugin.urlPay.url"
                                @click="generateLnkPayment()">
                                
                                Gerar link de pagamento
                            </div>
                        </div>

                        <div class="load" v-if="modalPlugin.urlPay.load"></div>

                        <div class="url-pay" v-if="!modalPlugin.urlPay.load && modalPlugin.urlPay.url">
                            <div class="btn-copy" :class="{copying: sectionManage.copying}" @click="copyCode(modalPlugin.urlPay.url)">
                                <span>Copiar link</span>
                            </div>

                            <div class="url">
                                <span>{{modalPlugin.urlPay.url}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "@/components/Header.vue";
    import HeaderStore from "@/components/HeaderStore.vue";

    import getMyContentLanguage from "@/services/contentLanguage.js";

    import moment from 'moment';

    import customScriptsGeneral from "./script-store-general.js";
    import customScriptsLinks from "./script-store-links.js";
    import customScriptsPlugin from "./script-store-plugin.js";
    import customScriptsWebHooks from "./script-store-webhooks.js";
    import customScriptsLogs from "./script-store-logs.js";

    export default {
        components: {
            Header,
            HeaderStore
        },

        data(){
            return Object.assign(
                {},
                customScriptsGeneral.data.call(this),
                customScriptsLinks.data.call(this),
                customScriptsPlugin.data.call(this),
                customScriptsWebHooks.data.call(this),
                customScriptsLogs.data.call(this)
            )
        },

        async mounted(){
            await customScriptsGeneral.mounted.call(this), customScriptsPlugin.mounted.call(this)
        },

        methods: {
            ...customScriptsGeneral.methods,
            ...customScriptsLinks.methods,
            ...customScriptsPlugin.methods,
            ...customScriptsWebHooks.methods,
            ...customScriptsLogs.methods,

            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
            },

            getMyLanguage(group, code) {
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code);
            },

            dateTime(value) {
                const format = this.flagSelected === 'br' ? 'pt' : this.flagSelected;
                return moment.utc(value).locale(format).format('DD/MM/YY HH:mm');
            },

            datePeriod(value) {
                const format = this.flagSelected === 'br' ? 'pt' : this.flagSelected;
                return moment.utc(value).locale(format).format('DD/MM/YY');
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        },

        created() {
            const meta = document.querySelector('meta[name="robots"]')
            if (meta) {
                meta.content = 'noindex,nofollow'
            } else {
                const newMeta = document.createElement('meta')
                newMeta.name = 'robots'
                newMeta.content = 'noindex,nofollow'
                document.getElementsByTagName('head')[0].appendChild(newMeta)
            }
        },
    };
</script>

<style src="./custom-links.scss" lang="scss" scoped />
<style src="./custom-plugin.scss" lang="scss" scoped />
<style src="./custom-webhook.scss" lang="scss" scoped />
<style src="./custom-logs.scss" lang="scss" scoped />